import { Button, Card, Divider, Flex, Input, Typography, message } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = () => {
    setIsLoading(true);

    messageApi.open({
      type: "loading",
      content: "Efetuando login...",
    });

    login(email, password)
      .then((response) => {
        if (response.status === 200) {
          message.success("Login efetuado com sucesso!", 2.5);
          navigate("/");
        } else {
          message.error("Usuário ou senha inválidos.");
        }
      })
      .catch((error) => {
        console.error(error);
        message.error("Ocorreu um erro durante o login.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Flex justify="center" align="center" vertical style={{ height: "100vh" }}>
      {contextHolder}
      <Card style={{ width: "50%", maxWidth: "500px" }}>
        <Flex align="center" justify="center">
          <img
            src={"icons/logo_horizontal.svg"}
            alt="logo"
            style={{ width: "300px" }}
          />
        </Flex>
        <Divider />
        <Flex vertical gap={15} align="center" style={{ marginTop: "15px" }}>
          <Input
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            onPressEnter={handleLogin}
          />
          <Input.Password
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Senha"
            onPressEnter={handleLogin}
          />
          <Flex justify="center" align="center" vertical>
            <Typography.Paragraph
              align="center"
              type="secondary"
              style={{ margin: 0 }}>
              Não tem um usuário ou esqueceu sua senha?
            </Typography.Paragraph>
            <Typography.Paragraph type="secondary" align="center">
              Entre em contato com o administrador do sistema.
            </Typography.Paragraph>
          </Flex>
          <Button
            onClick={handleLogin}
            type="primary"
            style={{ width: "50%" }}
            loading={isLoading}>
            Login
          </Button>
        </Flex>
      </Card>
    </Flex>
  );
}
